import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {createItem, getList} from "../../services/service";
import {selectUser} from "../../features/user/userSlice";
import ComboboxComponent from "../Combobox";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

export default function ModalAddProfileSystemSpecification({
                                                               open,
                                                               setOpen,
                                                               treeSelectId,
                                                               supplierId,
                                                               fetchData
                                                           }) {
    const cancelButtonRef = useRef(null);
    const [applicationTypeList, setApplicationTypeList] = useState([]);
    const [sideTypeList, setSideTypeList] = useState([]);
    const [articleList, setArticleList] = useState([]);

    // const [supplierId, setSupplierId] = useState(null);
    const [productId, setProductId] = useState(null);
    const [priority, setPriority] = useState(null);
    const [name, setName] = useState(null);
    const [applicationType, setApplicationType] = useState(null);
    const [sideType, setSideType] = useState(null);


    const {token} = useSelector(selectUser);
    const {t} = useTranslation();
    const navigate = useNavigate();

    const fetchDataApplicationTypeList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/specification/enum/application/type`,
            token
        );
        if (response.success) {
            setApplicationTypeList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name,
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };


    const fetchDataSideTypeList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/specification/enum/side/type`,
            token
        );
        if (response.success) {
            setSideTypeList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name,
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataArticleList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/article/product`,
            token
        );
        if (response.success) {
            setArticleList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (open) {
            fetchDataApplicationTypeList();
            fetchDataSideTypeList();
            fetchDataArticleList();
        }
    }, [open]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onInsert = () => {
        (async () => {
            let data = {
                priority: priority,
                productId: productId,
                supplierId: supplierId,
                sideType: sideType,
                applicationType: applicationType,
                profileSystemId: treeSelectId,
            };
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/specification`;
            let response = await createItem(url, token, data);
            if (response.success) {
                fetchData();
                setOpen(false);
                toast.success(t('action.add_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            }
        })();
    };

    const handle_application = (value) => {
        setApplicationType(value.value);
    };

    const handle_sideways = (value) => {
        setSideType(value.value);
    };

    const handle_article = (value) => {
        setProductId(value.id);
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setOpen}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                <div>
                                    <div className="">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {t('add_profile_system_specification')}
                                        </Dialog.Title>
                                        <div className="mt-8">
                                            <div className="mt-3 col-span-12 sm:col-span-6">
                                                <label
                                                    htmlFor="priority"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    {t('priority')}
                                                </label>
                                                <input
                                                    type="number"
                                                    name="priority"
                                                    id="priority"
                                                    required
                                                    onChange={(e) => {
                                                        setPriority(e.target.value);
                                                    }}
                                                    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <ComboboxComponent
                                                    label={t('article')}
                                                    data={articleList}
                                                    onChange={handle_article}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <ComboboxComponent
                                                    label={t('application')}
                                                    data={applicationTypeList}
                                                    onChange={handle_application}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <ComboboxComponent
                                                    label={t('sideways')}
                                                    data={sideTypeList}
                                                    onChange={handle_sideways}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="mt-8 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                        onClick={onInsert}
                                    >
                                        {t('save')}
                                    </button>
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                        onClick={() => setOpen(false)}
                                        ref={cancelButtonRef}
                                    >
                                        {t('cancel')}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
